function restoreWindowScroll(scrollX, scrollY) {
  if (!/jsdom/i.test(window.navigator?.userAgent || '')) {
    window.scrollTo(scrollX, scrollY);
  }
}

export function lockDailyStatusDocument({ restoreScroll = restoreWindowScroll } = {}) {
  const root = document.documentElement;
  const body = document.body;
  const scrollX = window.scrollX || window.pageXOffset || 0;
  const scrollY = window.scrollY || window.pageYOffset || 0;
  const scrollbarWidth = Math.max(0, window.innerWidth - root.clientWidth);
  const bodyPaddingRight = Number.parseFloat(window.getComputedStyle(body).paddingRight) || 0;
  const previousLockMarker = body.getAttribute('data-daily-status-scroll-locked');
  const previousRootStyles = {
    overflow: root.style.overflow,
    overscrollBehavior: root.style.overscrollBehavior,
  };
  const previousBodyStyles = {
    overflow: body.style.overflow,
    overscrollBehavior: body.style.overscrollBehavior,
    position: body.style.position,
    top: body.style.top,
    left: body.style.left,
    right: body.style.right,
    width: body.style.width,
    boxSizing: body.style.boxSizing,
    paddingRight: body.style.paddingRight,
  };

  root.style.overflow = 'hidden';
  root.style.overscrollBehavior = 'none';
  body.style.overflow = 'hidden';
  body.style.overscrollBehavior = 'none';
  body.style.position = 'fixed';
  body.style.top = `-${scrollY}px`;
  body.style.left = `-${scrollX}px`;
  body.style.right = '0';
  body.style.width = '100%';
  body.style.boxSizing = 'border-box';
  body.style.paddingRight = `${bodyPaddingRight + scrollbarWidth}px`;
  body.dataset.dailyStatusScrollLocked = 'true';

  return () => {
    Object.assign(root.style, previousRootStyles);
    Object.assign(body.style, previousBodyStyles);
    if (previousLockMarker === null) delete body.dataset.dailyStatusScrollLocked;
    else body.setAttribute('data-daily-status-scroll-locked', previousLockMarker);
    restoreScroll(scrollX, scrollY);
  };
}
